import React, { useEffect, useState } from "react";
import "./Navbar.css";
import logo from "../logo11.jpeg";

const navLinks = ["Services", "Locations", "Contact"];

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Replaces the Framer Motion "initial" and "animate" logic
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollTo = (id) => {
    const element = document.getElementById(id.toLowerCase());
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className={`navbar ${isVisible ? "slide-down" : ""}`}>
      <div className="nav-container">
        {/* Logo */}
        <img src={logo} alt="View Secure Technologies" className="nav-logo" />

        {/* Desktop Links */}
        <div className="nav-links">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link)}
              className="nav-item"
            >
              {link}
            </button>
          ))}
        </div>

        {/* Call Button */}
        <a href="tel:9884135738" className="nav-cta">
          📞 Call Now
        </a>
      </div>
    </nav>
  );
};

export default Navbar;